var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.pagelets)?_c('div',{staticClass:"columns is-centered"},_vm._l((_vm.pagelets),function(pagelet){return _c('Pagelet',{key:pagelet.fields.title,attrs:{"pageData":pagelet,"rootPageData":_vm.rootPageData,"size":_vm.panelgroupsize,"type":pagelet.fields.type,"background":_vm.background}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }